import { DirectUpload } from '@rails/activestorage'
import Alpine from 'alpinejs'

const data = (params = {}) => ({
  /**
   *  Data
   */
  sizeLimit: -1, // image file size
  url: '/rails/active_storage/direct_uploads', // upload url, 預設是rails的rails_direct_uploads_path
  file: null,
  fileTouched: false,
  progress: 0,
  signedId: '', // blob signed_id after create
  status: 'init', // ['init', 'uploading', 'success', 'error']
  image: '',

  get fileValid() {
    return this.file?.type?.match(/^image\//i) && (this.sizeLimit === -1 || this.file.size <= this.sizeLimit)
  },

  /**
   *  Targets
   */

  targets: {
    file: {
      ['@change']: 'onChange',
      ['@drop.prevent']: 'onDrop',
      ['@dragover.prevent']: '',
      ['@direct-upload:manaul-cancel.window']: "onCancel",
    },
    previewImage: {
      [':src']: "status === 'success' ? image : ''",
    },
    fileField: {
      [':value']: 'signedId',
      [':disabled']: "!signedId",
    },
  },

  /**
   *  Main & Event Callback
   */

  init() {
    this.fileValueChanged()
    this.progressValueChanged()
  },

  onChange(e) {
    if(e.currentTarget.files[0]) {
      this.fileTouched = true
      this.file = e.currentTarget.files[0]
    }
  },

  onDrop(e) {
    this.fileTouched = true
    this.file = this.getTransferFile(e)
  },

  onCancel() {
    this.progress = 0
    this.signedId = ''
    this.image = ''
  },

  /**
   *  Value Changed
   */
  fileValueChanged() {
    this.$watch('file', file => {
      this.resetData()
      if (!file) { return }
      if (!this.fileValid) {
        this.status = 'error'
        return
      }

      this.image = URL.createObjectURL(file)
      this.upload()
    })
  },

  progressValueChanged() {
    this.$watch('progress', async (progress) => {
      if (progress === 100) {
        await Alpine.nextTick()
        this.status = 'success'
      }
    })
  },

  /**
   *  Private Function
   */

  getTransferFile(e) {
    if (e.dataTransfer.items) {
      const firstItem = e.dataTransfer.items[0]
      if (!firstItem || firstItem.kind !== 'file') { return null }

      return firstItem.getAsFile()
    } else {
      const firstItem = e.dataTransfer.files[0]
      if (!firstItem) { return null }

      return firstItem
    }
  },

  upload() {
    if ( !this.url || !this.file ) { return }

    const callbacks = this
    const instance = new DirectUpload(this.file, this.url, callbacks)

    this.status = 'uploading'

    instance.create((error, blob) => {
      if (error) {
        this.status = 'error'
        console.error(error)
      } else {
        // Add an appropriately-named hidden input to the form
        // with a value of blob.signed_id
        this.signedId = blob.signed_id
        this.progress = 100
      }
    })
  },

  // MUST: becase `DirectUpload` will use
  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener('progress', ({ loaded, total }) => {
      this.progress = Math.floor(loaded * 100.0 / total)
    })
  },

  resetData() {
    this.progress = 0
    this.signedId = ''
    this.status = 'init'
    this.image = ''
  },

  ...params
})

Alpine.data('directUploadImage', data)
export default data
